import builder from '../builder';
import ButtonRefreshArrows from '../../streamline-icons/bold/button-refresh-arrows.svg';

export default builder('IconButtonRefreshArrowsBold', ButtonRefreshArrows);
